// --- START OF FILE src/pages/ForgotPassword.jsx ---

import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useTranslation } from 'react-i18next'; // MODIFICACIÓN: Importar useTranslation
import { auth } from '../firebase'; 
import '../styles/ForgotPassword.css'; 

function ForgotPassword() {
  const { t } = useTranslation(); // MODIFICACIÓN: Hook de traducción
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(t('passwordResetEmailSentMsg')); // MODIFICACIÓN
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/invalid-email') {
         setMessage(t('passwordResetEmailSentMsg')); // MODIFICACIÓN (mensaje genérico)
      } else {
        setError(t('failedToSendResetEmailError')); // MODIFICACIÓN
        console.error("Password reset error:", err);
      }
    }
    setIsSubmitting(false);
  };

  return (
    <div className="forgot-password-screen">
      <div className="forgot-password-container">
        <div className="forgot-password-logo">
          <img src="/Reseye Logo.png" alt={t('logoAltText')} /> {/* MODIFICACIÓN */}
        </div>
        <div className="forgot-password-form-section">
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <h2>{t('forgotPasswordTitle')}</h2> {/* MODIFICACIÓN */}
            <p className="instructions">
              {t('forgotPasswordInstructions')} {/* MODIFICACIÓN */}
            </p>

            <div className="input-group">
              <label htmlFor="email">{t('emailAddressLabel')}</label> {/* MODIFICACIÓN */}
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('emailPlaceholder')} // MODIFICACIÓN
                required
                disabled={isSubmitting} // Mantener estado de deshabilitación
              />
            </div>

            {message && <p className="message success-message">{message}</p>} {/* El mensaje ya se traduce en handleSubmit */}
            {error && <p className="message error-message">{error}</p>} {/* El mensaje ya se traduce en handleSubmit */}

            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? t('sendingButton') : t('sendResetLinkButton')} {/* MODIFICACIÓN */}
            </button>

            <div className="back-to-login">
              <RouterLink to="/login">{t('backToLoginLink')}</RouterLink> {/* MODIFICACIÓN */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
// --- END OF FILE src/pages/ForgotPassword.jsx ---